import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthState } from 'app/core/state/auth.state';

/**
 * Guard that redirects users to the appropriate landing page based on their roles.
 *
 * ROLE → DEFAULT ROUTE:
 * - SuperAdmin, SystemAdmin → /admin/select-context
 * - OrganizationAdmin, AnalyticsAdmin, Development, Demo → /dashboardv2
 * - No roles → /unauthorized
 */
export const SmartRedirectGuard: CanActivateFn = (route, state) => {
    const router = inject(Router);
    const authState = inject(AuthState);

    // Check if there's a stored redirect URL from before login
    const storedRedirect = sessionStorage.getItem('redirectUrl');
    if (storedRedirect && storedRedirect !== '/' && storedRedirect !== '/signed-in-redirect') {
        sessionStorage.removeItem('redirectUrl');
        // Validate the stored redirect is accessible to the user
        if (authState.canAccessRoute(storedRedirect)) {
            router.navigateByUrl(storedRedirect);
            return false;
        }
    }

    // Redirect based on user roles using defaultRoute
    const defaultRoute = authState.defaultRoute();
    console.log('[SmartRedirectGuard] Redirecting to:', defaultRoute, '| Roles:', authState.userRoles());
    router.navigate([defaultRoute]);

    return false; // Always return false as we're redirecting
};
